import { Loading } from 'element-ui'
let install = Vue => {
  if (install.installed) return
  Vue.mixin({
    data() {
      return {
        loadingInstance: null
      }
    },
    methods: {
      showLoad(msg) {
        this.loadingInstance = Loading.service({
          lock: true,
          fullscreen: true,
          text: msg || 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      },
      closeLoad() {
        if (this.loadingInstance) {
          let t = setTimeout(() => {
            this.loadingInstance.close()
            clearTimeout(t)
          }, 300)
        }
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/mixins/showLoading.js